import { useTranslate } from 'react-redux-multilingual/lib/context'

function useTranslation() {
	return useTranslate()
}
export default useTranslation
